export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12782.8963cdc9.jpg";